'use strict';

/**
 * Toogle Carousel Controls(Prev and Next buutons) display
 * @param {Object} $carousel carousel element - jquery object
 */
function toggleCarouselControls($carousel) {
    if ($carousel.length) {
        var $carouselInner = $carousel.find('.carousel-inner');
        var totalSlides = $carouselInner.length ? $carouselInner.children('.carousel-item').length : 0;
        var activeIndex = $carouselInner.find('.carousel-item.active').index();
        var isFirstCarouselItem = activeIndex === 0;
        if (isFirstCarouselItem) {
            $carousel.find('.carousel-control-next').removeClass('d-none');
            $carousel.find('.carousel-control-prev').addClass('d-none');
        } else if (activeIndex === (totalSlides - 1)) {
            $carousel.find('.carousel-control-prev').removeClass('d-none');
            $carousel.find('.carousel-control-next').addClass('d-none');
        } else {
            $carousel.find('.carousel-control-prev').removeClass('d-none');
            $carousel.find('.carousel-control-next').removeClass('d-none');
        }
    }
}

module.exports = {
    toggleCarouselControls: toggleCarouselControls
};
